export const CONTACT_EMAIL = 'team@fandb.app';
